<template>
  <div>
    <div class="innerItem">
      <button type="button" class="btn btnFull btnPrimary" @click="confirmSave">{{locale.save}}</button>
      <button type="button" class="mt15 btn btnFull btnWhite" @click="setVersionHistory(true)">{{locale.versionhistory}}</button>
    </div>
    <!-- 다른사이트 상품 복사 -->
    <div v-if="isSuperadmin" class="innerItem">
      <button type="button" class="btn btnFull btnLightGrey" @click="importProductLayer = true"><i style="font-family: none">⚠️</i> 상품 불러오기</button>
    </div>
    <!-- //다른사이트 상품 복사 -->
    <div class="innerItem">
      <button type="button" class="btn btnFull" @click="setOrder">{{locale.product_set_order}}</button>
    </div>
    <!-- title -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.title}}</div>
      <input type="text" class="input" v-model="setting.title">
    </div>
    <!-- //title -->
    <!-- submit code -->
    <div class="innerItem">
      <div class="label mb5 setLabel setLabel">
        {{locale.submit}}
        <button type="button" class="btn btnWhite sizeXs" @click="applyAll('submitTo')">{{locale.apply_all}}</button>
      </div>
      <p class="sysMessage">
        <router-link v-if="userRole === 'admin'"
          :to="{name: 'admin', params: {admin: 'codelist'}}"
          data-nav="admin">
          {{`[${locale.submit_category_setting}] ${locale.nav_admin} > ${locale.admin_codelist}`}}
        </router-link>
        <span v-else>{{`[${locale.submit_category_setting}] ${locale.message_admin_only}`}}</span>
      </p>
      <select v-model="setting.submitTo" class="input">
        <option value="">{{locale.admin_codelist}}</option>
        <option v-for="code in codeList" :key="code.id" :value="code.id">{{code.label}}</option>
      </select>
    </div>
    <!-- //submit code -->
    <!-- 전송카테고리(알림톡 등 전송과 함께 부가적으로 처리하기 위한 코드) -->
    <div v-if="submitCategory && submitCategory.length">
      <div class="innerItem">
        <div class="label mb5 setLabel setLabel">
          {{locale.admin_submitcategory}}
          <button type="button" class="btn btnWhite sizeXs" @click="applyAll('submitCategory')">{{locale.apply_all}}</button>
        </div>
        <p class="sysMessage">{{locale.submitcategory_sys_message}}</p>
        <select name="" id="" class="input" v-model="setting.submitCategoryId" @change="setSubmitCategory">
          <option
            v-for="cate in submitCategory"
            :key="cate.id"
            :value="cate.id">
            {{cate.id === '#none' ? locale.none : cate.label}}
            </option>
        </select>
      </div>
    </div>
    <!-- //전송카테고리(알림톡 등 전송과 함께 부가적으로 처리하기 위한 코드) -->
    <!-- 이용장소 -->
    <div class="innerItem">
      <div class="label mb5 setLabel">
        {{locale.place}}
        <button type="button" class="btn btnWhite sizeXs" @click="togglePlaceLayer">{{locale.setting}}</button>
      </div>
      <div class="checkbox">
        <input type="checkbox" name="product_place" id="product_place_on" v-model="setting.place">
        <label for="product_place_on">{{locale.place_use}}</label>
      </div>
      <div v-if="placeLayer" class="layer placeLayer">
        <div class="inner">
          <button type="button" class="btnClose" @click="togglePlaceLayer"><span class="blind">close</span></button>
          <h2 class="layerTitle">{{locale.place_setting}}</h2>
          <div class="placeList">
            <div class="placeItem"
              v-for="(item, index) in placeList"
              :key="index">
              <!-- delete item -->
              <button type="button" class="btnDel"
                @click="delPlace(index)">
                <img src="@/assets/img/ico_close_black.svg" alt="delete item" />
              </button>
              <!-- //delete item -->
              <div class="translation mb5">
                <input v-model="item[lang.default]" type="text" class="input" @focusout="setDefaultVal(index)">
                <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen(index)">
                  <span class="blind">{{locale.language_specific_set}}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
                </button>
              </div>
            </div>
          </div>
          <button type="button" class="btn btnWhite btnFull mt15" @click="addPlace">{{locale.add}}</button>
        </div>
      </div>
    </div>
    <!-- //이용장소 -->
    <!-- available table -->
    <div class="innerItem setAvailable">
      <div class="label mb5 setLabel">
        {{locale.page_set_available}}
        <button type="button" class="btn btnWhite sizeXs" @click="applyAll('available')">{{locale.apply_all}}</button>
      </div>
      <div class="mb10">
        <span class="checkbox radio">
          <input type="radio" name="page_available" id="page_available_always" value="01" v-model="setting.available.state">
          <label for="page_available_always">{{locale.page_available_always}}</label>
        </span>
        <span class="checkbox radio">
          <input type="radio" name="page_available" id="page_available_each" value="02" v-model="setting.available.state">
          <label for="page_available_each">{{locale.page_available_each}}</label>
        </span>
      </div>
      <button type="button" class="btn btnWhite btnFull" @click="setAvailableTime(true)">{{locale.setting}}</button>
      <AvailableTime
        v-if="availableLayer"
        :locale="locale"
        :available="setting.available"
        @apply="applyAvailableTime"
        @close="setAvailableTime(false)" />
    </div>
    <!-- //available table -->
    <!-- default thumbnail -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{ locale.replace_default_image }}</div>
      <div class="mb10">
        <span class="checkbox">
          <input type="checkbox" id="set_default_img" v-model="setting.setDefaultImage">
          <label for="set_default_img">{{ locale.message_default_image_replace }}</label>
        </span>
      </div>
    </div>
    <!-- //default thumbnail -->
    <!-- set thumbnail ratio -->
    <div v-if="prevMode === 'tablet'" class="innerItem">
      <div class="label mb5 setLabel">{{locale.thumbnail_size}}</div>
      <div class="ratioBtns mb10">
        <button
          v-for="(r, i) in ratio"
          :key="i"
          :data-ratio="`ratio_${r.id}`"
          class="ratioBtn"
          type="button"
          @click="setAllThumbRatio(r.id)">
          {{ r.label }}
        </button>
      </div>
    </div>
    <!-- //set thumbnail ratio -->
    <!-- view type -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.viewtype}}<span class="mobileOnly">Mobile Only</span></div>
      <div class="viewType">
        <span class="type" data-type="grid">
          <input type="radio" name="view_type" id="view_type_grid" value="grid" v-model="setting.viewType">
          <label for="view_type_grid"></label>
        </span>
        <span class="type" data-type="list">
          <input type="radio" name="view_type" id="view_type_list" value="list" v-model="setting.viewType">
          <label for="view_type_list"></label>
        </span>
      </div>
    </div>
    <!-- //view type -->
    <!-- sortby -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.sorting}}<span class="mobileOnly">Mobile Only</span></div>
      <div>
        <div class="checkbox mb10">
          <input type="checkbox" id="product_sort_active" v-model="setting.activeSort">
          <label for="product_sort_active">{{locale.priority_applied}}</label>
        </div>
        <p class="sysMessage">{{locale.message_sorting_1}}</p>
      </div>
      <div v-if="setting.activeSort" class="mt10">
        <div class="mb10">
          <select class="input select" v-model="setting.sortby">
            <option v-for="(sort, index) in sortby" :key="index" :value="sort">
              {{locale[`sortby_${sort}`]}}
            </option>
          </select>
        </div>
        <div class="checkbox onoff mb5 displaySort" :class="{active: setting.displaySort}">
          <input type="checkbox" id="product_sort_display" v-model="setting.displaySort">
          <label for="product_sort_display">{{locale.enabled_select_sortby}}</label>
        </div>
        <div class="mb10"><p class="sysMessage">{{locale.message_product_sort_activate}}</p></div>
      </div>
    </div>
    <!-- sortby -->
    <!-- promotion -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.promotion}}</div>
        <div>
          <button type="button" class="btn btnFull" @click="setPromotion(true)">{{locale.product_promotion_manage}}</button>
        </div>
    </div>
    <!-- //promotion -->
    <!-- guest type -->
    <div v-if="hasGuestType" class="innerItem">
      <div class="label mb5 setLabel">{{locale.guesttype_setting}}</div>
      <div>
        <button type="button" class="btn btnFull" @click="guestTypeOpen">{{locale.setting}}</button>
      </div>
    </div>
    <!-- //guest type -->
    <!-- 언어별 세팅 -->
    <LangValue v-show="langValueLayer"
      :locale="locale"
      :langValue="langValue"
      :textarea="false"
      :title="locale.language_specific_set"
      @close="onLangValueClose" />
    <!-- //언어별 세팅 -->
    <!-- 게스트타입 -->
    <GuestType v-if="guestTypeLayer"
      :locale="locale"
      :guestType="setting.guestType"
      :btnApplyAll="true"
      @apply="setGuestType"
      @close="guestTypeClose" />
    <!-- //게스트타입 -->
    <!-- 저장 전 메모 -->
    <Memo v-if="saveMemoLayer"
      :locale="locale"
      @save="saveMemo"
      @close="closeMemo" />
    <!-- //저장 전 메모 -->
    <!-- 버전히스토리 -->
    <VersionHistory v-if="versionHistory.active"
      :locale="locale"
      :file="versionHistory.file"
      :currentVer="currentVer"
      @load="loadVersion"
      @close="setVersionHistory(false)" />
    <!-- //버전히스토리 -->
    <!-- 저장 전 메모 -->
    <SetPromotion v-if="promotionLayer"
      :locale="locale"
      @updatePromotion="updatePromotion"
      @close="setPromotion(false)" />
    <!-- //저장 전 메모 -->
    <!-- 버전파일 불러오기 -->
    <ImportVersionFile v-if="importProductLayer"
      :locale="locale"
      @load="importProduct"
      @close="importProductLayer = false" />
    <!-- //버전파일 불러오기 -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UTIL from '@/common/util'
import regExp from '@/common/regExp'
import LangValue from '@/components/Util/LangValue.vue'
import GuestType from '@/components/Util/GuestType.vue'
import AvailableTime from '@/components/Util/AvailableTime'
import VersionHistory from '@/components/Util/VersionHistory'
import Memo from '@/components/Util/Memo'
import SetPromotion from '@/components/Product/SetPromotion'
import ImportVersionFile from '@/components/Util/ImportVersionFile'

export default {
  name: 'ProductItemSetting',
  props: [
    'locale',
    'lang',
    'list',
    'setting',
    'hasGuestType',
    'submitCategory',
    'currentVer',
    'ratio',
    'prevMode'
  ],
  components: {
    LangValue,
    GuestType,
    AvailableTime,
    VersionHistory,
    Memo,
    SetPromotion,
    ImportVersionFile
  },
  computed: {
    ...mapGetters({
      getCode: 'admin/submitCodeList'
    }),
    isSuperadmin () {
      return this.$store.getters['authentication/getAuthority']
    },
    codeList () {
      const list = this.getCode.filter(x => x.id !== 'system_amenity')
      return list
    },
    userRole () {
      return this.$store.getters['authentication/getAuthInfo'].userRole
    },
    setTime () {
      const interval = [ '00', '30' ]
      let list = []
      for (let i = 0; i <= 24; i++) {
        for (let j = 0; j < interval.length; j++) {
          list.push(`${('0' + i).slice(-2)}:${interval[j]}`)
        }
      }
      list.pop()
      return list
    }
  },
  watch: {
    placeList (list) {
      this.$emit('updatePlace', list)
    }
  },
  created () {
    this.$store.dispatch('admin/getCodes')
  },
  data () {
    return {
      codeValue: '',
      langValueLayer: false,
      langValue: {},
      langTarget: '',
      placeLayer: false,
      placeList: [],
      guestTypeLayer: false,
      availableLayer: false,
      sortby: [
        'name_asc',
        'name_desc',
        'price_asc',
        'price_desc',
        'created'
      ],
      versionHistory: {
        active: false,
        file: ''
      },
      saveMemoLayer: false,
      promotionLayer: false,
      importProductLayer: false
    }
  },
  methods: {
    isNextDay (from, to) {
      from = regExp.numberOnly(from)
      to = regExp.numberOnly(to)
      return to < from
    },
    setGuestType (data) {
      this.setting.guestType = data
      this.applyAll('guestType')
    },
    guestTypeOpen () {
      this.guestTypeLayer = true
    },
    guestTypeClose () {
      this.guestTypeLayer = false
    },
    togglePlaceLayer () {
      this.placeLayer = !this.placeLayer
      this.placeList = this.setting.placeList.map(x => x)
    },
    addPlace () {
      this.placeList.push({})
    },
    delPlace (index) {
      this.placeList = this.placeList.filter((x, i) => i !== index)
    },
    onLangValueOpen (index) {
      this.langTarget = index
      this.langValueLayer = true
      this.langValue = this.placeList[index]
      this.setDefaultVal(index)
    },
    onLangValueClose () {
      const index = this.langTarget
      this.placeList[index] = this.langValue
      this.langValueLayer = false
      this.langValue = {}
    },
    setDefaultVal (index) {
      const defaultLang = this.lang.default
      const fillLangs = UTIL.fillLangs(this.placeList[index], this.placeList[index][defaultLang])
      this.placeList[index] = fillLangs
    },
    setSubmitCategory () {
      const id = this.setting.submitCategoryId
      this.setting.submitCategory = this._.cloneDeep(this.submitCategory.find(x => x.id === id))
    },
    setAvailableTime (isOpen) {
      this.availableLayer = isOpen
    },
    applyAvailableTime (data) {
      this.setting.available = data
      this.setAvailableTime(false)
    },
    importProduct (data) {
      this.loadVersion(data.version, data.site, data.id)
      this.importProductLayer = false
    },
    // 버전히스토리
    setVersionHistory (isActive) {
      const id = this.$route.params.id
      this.versionHistory.active = isActive
      this.versionHistory.file = `product/item/${id}.json`
    },
    loadVersion (version, site, id) {
      this.$emit('loadVersion', version, site, id)
      setTimeout(() => {
        this.versionHistory.active = false
        this.versionHistory.file = ''
      }, 500)
    },
    confirmSave () {
      this.saveMemoLayer = true
    },
    saveMemo (memo) {
      this.$emit('saveMemo', memo)
      setTimeout(() => {
        this.closeMemo()
      }, 500)
      // this.save()
    },
    setPromotion (isOpen) {
      this.promotionLayer = isOpen
    },
    updatePromotion () {
      this.$emit('updatePromotion')
    },
    closeMemo () {
      this.saveMemoLayer = false
    },
    applyAll (target) {
      if (window.confirm(this.locale.confirm_product_apply_all)) {
        this.$emit('applyAllItem', target)
        if (target === 'submitCategory') {
          this.$emit('applyAllItem', 'submitCategoryId')
        }
      }
    },
    setAllThumbRatio (ratio) {
      if (window.confirm(`${this.locale.confirm_apply_all_thumb_size_1}\n${this.locale.confirm_apply_all_thumb_size_2}`)) {
        this.$emit('setThumbRatio', ratio)
      }
    },
    setOrder () {
      this.$emit('setItemOrder')
    },
    save () {
      if (window.confirm(this.locale.confirm_save)) {
        this.$emit('saveItem')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.placeLayer {
  .inner {
    max-width: 480px;
  }
  .placeItem {
    position: relative;
    padding: 15px 45px 15px 15px;
    border: 1px solid $color-lgrey2;
    background-color: $color-white;
    & + .placeItem {
      border-top: none;
    }
    .btnDel {
      position: absolute;
      top: 0;
      right: 0;
      width: 40px;
      height: 40px;
      padding: 10px;
    }
  }
}
.viewType {
  .type {
    display: inline-block;
    vertical-align: middle;
    label {
      display: block;
      padding: 4px;
      border: 1px solid $color-lgrey;
      cursor: pointer;
      &:before {
        content: "";
        display: block;
        width: 32px;
        height: 32px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        opacity: 0.15;
      }
    }
    & + .type {
      margin-left: 5px;
    }
    :checked+label {
      border-color: $color-dark;
      &:before {
        opacity: 0.75;
      }
    }
  }
  [data-type="grid"] label:before {
    background-image: url('~@/assets/img/ico_grid.png');
  }
  [data-type="list"] label:before {
    background-image: url('~@/assets/img/ico_list.png');
  }
}
.displaySort {
  &:not(.active) {
    opacity: 0.5;
  }
  &.active {
    color: $color-dark;
  }
}
</style>
